module.exports = "/_next/static/images/efb5cc18e316b0364862e9f27ea8718d-xpeer-lg.jpg";